export const SYSTEM_ADMINISTRATOR='System Admin';
export const CLIENT_ADMINISTRATOR='Client Admin';
export const USER = 'User'

export const PROFILE_URL = "/base/profile";
export const ORGANIZATION_URL = "/base/organization";
export const USERS_URL = "/base/users";
export const HOME_URL = "/base/home";
export const AI_VERIFICATION_CALLS_URL = "/base/ai-verification-calls";